import { Box, Typography, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { rememberHighlight } from 'src/colors';

type Variant = 'warning' | 'error';

interface Props {
  children: ReactNode;
  variant?: Variant;
  title?: string;
}

export const ReminderHighlight = ({
  children,
  variant = 'error',
  title = 'common:reminderHighlight.title',
}: Props) => {
  const {
    palette: { mode },
  } = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        px: 2.4,
        py: 2,
        border: '1px solid black',
        borderColor: rememberHighlight[variant][mode].border,
        backgroundColor: rememberHighlight[variant][mode].background,
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}>
      <Typography
        variant="subtitle2"
        fontWeight="500"
        color={rememberHighlight[variant][mode].title}>
        {t(title)}
      </Typography>

      {children}
    </Box>
  );
};
